var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import PagePlaylistAudio from "./PagePlaylistAudio";
import HTTP from "@/http";
import draggable from 'vuedraggable';
import _ from "lodash";
var PageHistory = (function (_super) {
    __extends(PageHistory, _super);
    function PageHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultImageSrc = "https://img.youtube.com/vi/dummy/0.jpg";
        _this.audios = [];
        _this.sort = "position";
        _this.sortItems = [
            { value: "position", text: "Default" },
            { value: "-position", text: "Reverse" },
            { value: "created_at", text: "Date added (newest)" },
            { value: "-created_at", text: "Date added (oldest)" },
        ];
        _this.loading = true;
        return _this;
    }
    Object.defineProperty(PageHistory.prototype, "imgSrc", {
        get: function () {
            if (this.audios.length) {
                return this.audios[0].imgSource;
            }
            return this.defaultImageSrc;
        },
        enumerable: true,
        configurable: true
    });
    PageHistory.prototype.getHistory = function () {
        var _this = this;
        HTTP.get("/views", { params: { all: true } })
            .then(function (response) {
            _this.audios = response.data;
            _this.loading = false;
        })
            .catch(function (response) {
        });
    };
    PageHistory.prototype.play = function (shuffled) {
        var _this = this;
        this.$store.dispatch("setPlaylist", []);
        this.$nextTick(function () {
            _this.$store.dispatch("setPlaylist", shuffled ? _.shuffle(_this.audios) : _this.audios);
            _this.$store.dispatch("setPosition", 0);
            _this.$nextTick(function () {
                _this.$store.dispatch("setState", 1);
            });
        });
    };
    PageHistory.prototype.onRouteChange = function () {
        this.getHistory();
    };
    PageHistory.prototype.onSortChange = function () {
        this.getHistory();
    };
    __decorate([
        Watch("$route", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageHistory.prototype, "onRouteChange", null);
    __decorate([
        Watch("sort"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageHistory.prototype, "onSortChange", null);
    PageHistory = __decorate([
        Component({
            components: {
                draggable: draggable,
                "playlist-audio": PagePlaylistAudio,
            },
        })
    ], PageHistory);
    return PageHistory;
}(Vue));
export default PageHistory;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pages/PageHistory.vue
// module id = 231
// module chunks = 0